import React, { useState, useEffect } from 'react'

import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import styled from 'styled-components'

const DropdownSelect = ({ options, id, selected, onChange }) => {
  return (
    <StyledWrapper id={id}>
      <Select
        options={options}
        value={selected ?? options[0]}
        onChange={onChange}
      />
    </StyledWrapper>
  )
}

export const SingleSelect = ({
  options,
  selected,
  onChange,
  placeholder,
  defaultValue,
  title,
  subText,
  wrapperClass,
}) => {
  return (
    <StyledWrapper className={wrapperClass}>
      <label>{title}</label>
      <Select
        defaultValue={defaultValue}
        options={options}
        value={selected ?? options[0]}
        onChange={onChange}
        placeholder={placeholder}
      />
      <sub>{subText}</sub>
    </StyledWrapper>
  )
}

export const CreatableSelectComponent = ({
  id,
  title,
  placeholder,
  noOption = false,
  menuIsOpen,
  selected = [],
  onChange,
  subText,
  options = [],
  wrapperClass,
  isMulti = true,
}) => {
  let openMenu = menuIsOpen
  let components = {}

  const [inputValue, setInputValue] = useState('')
  const [value, setValue] = useState(selected)

  useEffect(() => {
    setValue(selected)
  }, [selected])

  if (noOption) {
    components = {
      DropdownIndicator: null,
    }
    openMenu = false
  }

  const createOption = (label) => ({
    label,
    value: label,
  })

  const handleKeyDown = (event, isMulti) => {
    if (!inputValue) return

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (isMulti) {
          setValue((prev) => [...prev, createOption(inputValue)])
          onChange([...value, createOption(inputValue)])
        } else {
          setValue(createOption(inputValue))
          onChange(createOption(inputValue))
        }

        setInputValue('')
        event.preventDefault()
    }
  }

  const handleChange = (newValue) => {
    setValue(newValue)
    onChange(newValue)
  }

  return (
    <CreatableSelectWrapper id={id} className={wrapperClass}>
      <label>{title}</label>
      <CreatableSelect
        components={components}
        isClearable
        isMulti={isMulti}
        inputValue={inputValue}
        menuIsOpen={openMenu}
        value={value}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={(e) => handleKeyDown(e, isMulti)}
      />
      <sub>{subText}</sub>
    </CreatableSelectWrapper>
  )
}

const StyledWrapper = styled.div`
  width: 100%;
  font-size: 0.75rem;
  font-weight: 300;
  margin-bottom: 0.75rem;

  label {
    font-size: 0.75rem;
    font-weight: 300;
    color: rgb(14, 19, 36);
    margin-bottom: 4px;
    text-align: left;
  }

  &.error {
    label {
      color: red;
    }

    sub {
      font-size: 0.75rem;
      font-weight: 300;
      color: red;
    }

    .css-13cymwt-control {
      border-color: red;
    }
  }
`

const CreatableSelectWrapper = styled.div`
  width: 100%;

  border-radius: 3px;
  font-size: 0.875rem;
  font-weight: 300;
  margin-bottom: 1rem;
  z-index: 999;

  label {
    font-size: 0.75rem;
    font-weight: 300;
    color: rgb(14, 19, 36);
    margin-bottom: 4px;
    text-align: left;
  }

  &.error {
    label {
      color: red;
    }

    sub {
      font-size: 0.75rem;
      font-weight: 300;
      color: red;
    }

    .css-13cymwt-control {
      border-color: red;
    }
  }
`

export default DropdownSelect
